"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withRateLimiter = void 0;
const errors_1 = require("../errors");
const withRateLimiter = (wrappedFn, maxOps, intervalInMs, exceededErrorMessage) => {
    let start = Date.now();
    let numOps = 0;
    return async (...args) => {
        const now = Date.now();
        const elapsed = now - start;
        if (elapsed > intervalInMs) {
            start = now;
            numOps = 0;
        }
        if (numOps >= maxOps) {
            throw new errors_1.BridgeAPIError(exceededErrorMessage || 'Too many invocations.');
        }
        numOps = numOps + 1;
        return wrappedFn(...args);
    };
};
exports.withRateLimiter = withRateLimiter;
